import { createApp } from 'vue';
import App from './App.vue';

const appElement = document.getElementById('app');

const culture = appElement.dataset.culture;

createApp(App, { culture }).mount('#app')